import { formatDateOnly } from 'dashboard/helper/dateHelper';

const DEFAULT_YES = 'Sim';
const DEFAULT_NO = 'Não';

/**
 * Format a single raw value for ticket history display.
 * @param {string|boolean|null|undefined} raw - Raw value from API
 * @param {{ yesLabel?: string, noLabel?: string }} options - Labels for boolean (default: Sim/Não)
 * @returns {string}
 */
export const formatSingleHistoryValue = (raw, options = {}) => {
  const yesLabel = options.yesLabel ?? DEFAULT_YES;
  const noLabel = options.noLabel ?? DEFAULT_NO;

  if (raw === null || raw === undefined || raw === '') return '';
  if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return formatDateOnly(raw);
  }
  if (raw === true || raw === 'true') return yesLabel;
  if (raw === false || raw === 'false') return noLabel;
  return String(raw);
};

const MAX_HISTORY_DISPLAY_LENGTH = 35;

const truncateHistoryValue = str =>
  typeof str === 'string' && str.length > MAX_HISTORY_DISPLAY_LENGTH
    ? `${str.slice(0, MAX_HISTORY_DISPLAY_LENGTH - 1)}…`
    : str;

/**
 * Format ticket history old/new value for display.
 * Backend sends "Attribute name: value" for custom attributes; we format the value part
 * (date → dd/MM/yyyy, boolean → yesLabel/noLabel).
 *
 * @param {string|boolean|null|undefined} value - Value from history (may be "Label: value")
 * @param {{ yesLabel?: string, noLabel?: string }} options - Labels for boolean
 * @returns {string}
 */
export const formatHistoryValue = (value, options = {}) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' && value.includes(': ')) {
    const colonIndex = value.indexOf(': ');
    const label = value.slice(0, colonIndex);
    const raw = value.slice(colonIndex + 2).trim();
    const formatted = formatSingleHistoryValue(raw, options);
    const result = formatted !== '' ? `${label}: ${formatted}` : `${label}:`;
    return truncateHistoryValue(result);
  }
  return truncateHistoryValue(formatSingleHistoryValue(value, options));
};
